"use strict";

exports.__esModule = true;

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable */


/**
 * 默认最大并发为6
 * @type {number}
 */
var DEFAULT_MAX_CONNECTION = 6;
/**
 * 默认检查时间差为2s
 * @type {number}
 */
var INTERVAL = 2000;

var Queue = function () {
  /**
   * 同时请求最大连接数
   * @type {number}
   * @private
   */

  /**
   * 加载任务队列
   * @type {Array}
   */
  function Queue(config) {
    _classCallCheck(this, Queue);

    this.id = new Date().getTime();
    this.queue = [];
    this._loadingQueue = [];
    this._maxConnection = DEFAULT_MAX_CONNECTION;
    this._policeInterval = 0;

    this._removeLoadItem = function (item) {
      var l = this._loadingQueue.length;
      for (var i = 0; i < l; i++) {
        if (this._loadingQueue[i] === item) {
          this._loadingQueue.splice(i, 1);
          break;
        }
      }
    };

    this.config = config || {};

    this.scrollHandler = this.scrollHandler.bind(this);
    // 监听滚动事件
    // TODO: 目前只考虑了body滚动，未考虑容器内滚动的情况
    this.bindEventListener(window);
  }
  /**
   * 检查定时器
   * @private
   */

  /**
   * 当前正在加载任务队列
   * @type {Array}
   * @private
   */

  /**
   * 队列标识
   * @type {number}
   */


  Queue.prototype.setMaxConnection = function setMaxConnection(maxConnection) {
    this._maxConnection = maxConnection;
  };

  Queue.prototype.bindEventListener = function bindEventListener(container) {
    if (container && container.addEventListener) {
      container.addEventListener("scroll", this.scrollHandler, true);
      container.addEventListener("resize", this.scrollHandler);
    }
  };

  /**
   * 获取img对应的blob
   * @param option
   * @returns {Promise}
   */


  Queue.prototype.get = function get(option) {
    var xhr = new XMLHttpRequest(),
        url = option.url || "";

    xhr.timeout = option.timeout || 10000;
    xhr.responseType = "blob";
    xhr.open("GET", url);
    xhr.send();

    return new Promise(function (resolve, reject) {
      xhr.onload = function () {
        if (xhr.status === 200) {
          var blob = xhr.response,
              urlCreator = window.URL || window.webkitURL,
              imageUrl = urlCreator.createObjectURL(blob);

          resolve(imageUrl);
        } else {
          reject(xhr);
        }
      };
    });
  };

  /**
   * 验证该对象是否已经被加载过，或者队列是否已经包含
   * @param item
   */


  Queue.prototype.validate = function validate(item) {
    return !item.loaded;
  };

  /**
   * 组件是否在视野内
   * @param component
   */


  Queue.prototype.isInViewPort = function isInViewPort(component) {
    if (!component) return false;
    // 计算dom节点所在位置
    var windowHeight = window.innerHeight,
        windowWidth = window.innerWidth,
        offsetRatio = 2,
        // 偏差比例，默认认为当前视野内前后两个屏幕内的都未视野内
    domNode = _reactDom2.default.findDOMNode(component),
        rect = domNode && domNode.getBoundingClientRect() || {};
    return Math.abs(rect.top) < offsetRatio * windowHeight && Math.abs(rect.left) < offsetRatio * windowWidth;
  };

  /**
   * 添加预加载对象
   */


  Queue.prototype.add = function add(item) {
    var inputArr = item instanceof Array ? item : [item];
    for (var i = 0; i < inputArr.length; i++) {
      var component = inputArr[i];
      if (this.validate(component)) {
        // 如果在视野内，需要立即加载，不然影响体验
        if (this.isInViewPort(component)) {
          this._loadItem(component, true);
        } else {
          this.queue.push(component);
        }
      } else {
        // 加载过了，直接显示
        component.show();
      }
    }
  };

  /**
   * 滚动触发开始加载
   */


  Queue.prototype.scrollHandler = function scrollHandler() {
    this.load();
  };

  /**
   * 开始加载
   */


  Queue.prototype.load = function load() {
    if (this.queue.length > 0 && this._loadingQueue.length < this._maxConnection) {
      this._loadNext();
      // 开始监控
      if (!this._policeInterval) {
        this._policeInterval = setInterval(this.checkQueue.bind(this), INTERVAL);
      }
    }
  };

  /**
   * 出队列
   * @param item
   */


  Queue.prototype.output = function output(item) {
    if (item && item.show) {
      item.show();
    }
  };

  /**
   * 检测任务队列
   */


  Queue.prototype.checkQueue = function checkQueue() {
    // 任务队列卡住了，需要人为疏通放水
    if (this._loadingQueue.length >= this._maxConnection) {
      console.log("stucked, loadingQueue");
      // 暂定策略：每次放前两个
      this._loadingQueue.splice(0, 2);
      // 继续加载下一个
      this._loadNext();
    } else if (this.queue.length === 0 && this._loadingQueue.length === 0) {
      // 清除定时器
      this._policeInterval = clearInterval(this._policeInterval);
    }
  };

  /**
   * 加载下一个
   * @private
   */


  Queue.prototype._loadNext = function _loadNext() {
    if (this.queue.length > 0) {
      // TODO: 目前是按入队的顺序加载，实际上应该按距离视野的距离排序，但是排序会导致性能更差
      for (var i = 0; i < this.queue.length; i++) {
        if (this._loadingQueue.length >= this._maxConnection) {
          break;
        }
        var item = this.queue[i];
        // 改变当前队列
        this.queue.splice(i, 1);
        i--;
        // 加载
        this._loadItem(item);
      }
    }
  };

  /**
   * 加载组件
   * @param item
   * @param independenttly 是否独立加载，true时，加载结束后不会自动加载下一个
   * @private
   */


  Queue.prototype._loadItem = function _loadItem(item, independenttly) {
    // 加入队列
    this._loadingQueue.push(item);
    // 加载
    this._startLoadItem(item, independenttly);
  };

  /**
   * 开始加载单个对象
   * @param item
   * @param independenttly 是否独立加载，true时，加载结束后不会自动加载下一个
   * @private
   */


  Queue.prototype._startLoadItem = function _startLoadItem(item, independenttly) {
    var _this = this;

    if (!item || !item.resource) return;

    var sendComplete = function sendComplete() {
      // 移除加载完成的item
      _this._removeLoadItem(item);

      if (!independenttly) {
        // 加载下一个
        _this._loadNext();
      }
    };

    // 加载成功
    var loadSuccess = function loadSuccess() {
      // 暴露组件开始加载成功hook
      item.onLoad && item.onLoad();

      // 显示
      item.show();

      // 当前item加载结束
      sendComplete();
    };

    // 加载失败
    var loadError = function loadError() {
      // 暴露组件开始加载失败hook
      item.onError && item.onError();
      // 当前item加载结束
      sendComplete();
    };

    var loadImage = function loadImage(imageUrl) {
      var image = new Image();

      image.onload = loadSuccess;

      image.onerror = loadError;

      image.src = imageUrl;

      // 通知组件开始加载hook
      item.onStart && item.onStart();
    };

    // 如果已经加载过了，直接出队
    if (item.loaded) {
      sendComplete();
      return;
    }

    // 开始加载
    var useBlob = this.config.useBlob;

    if (useBlob) {
      this.get({
        url: item.resource
      }).then(loadImage).catch(function (e) {
        loadError();
      });
    } else {
      loadImage(item.resource);
    }
  };

  return Queue;
}();

var _instance = null;

exports.default = _instance || (_instance = new Queue());